import React from 'react';
import { Link } from 'react-router-dom';

export const homeCardLink = (c) => {
  switch (c.dest_type) {
    case 'collection': return `/collection/${encodeURIComponent(c.dest_value)}`;
    case 'toon': return `/fiche/${encodeURIComponent(c.dest_value)}`;
    case 'recherche': return `/catalogue?q=${encodeURIComponent(c.dest_value)}`;
    default: return c.dest_value || '/catalogue';
  }
};

export const isExternalCard = (c) => c.dest_type === 'externe' || c.dest_type === 'html';

export const EditorialCard = ({ card, className = '', style, testid, badge }) => {
  const inner = (
    <>
      {card.cover_url
        ? <img src={card.cover_url} alt={card.titre} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        : <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg,#ed5c1f,#ff8a3d)' }} />}
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
      {badge && <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-primary text-white text-xs font-800 uppercase tracking-wide shadow-lg">{badge}</span>}
      <div className="absolute bottom-5 left-5 right-5 text-white">
        <h3 className="font-display font-700 text-2xl sm:text-3xl leading-tight drop-shadow-lg">{card.titre}</h3>
        {card.sous_titre && <p className="text-white/85 font-700 mt-1 text-sm sm:text-base">{card.sous_titre}</p>}
        <span className="inline-flex items-center gap-1.5 mt-3 px-4 py-1.5 rounded-full bg-secondary text-secondary-foreground text-sm font-800 shadow-md group-hover:gap-2.5 transition-all">Découvrir <span aria-hidden>→</span></span>
      </div>
    </>
  );
  const base = `group relative block rounded-3xl overflow-hidden h-56 sm:h-72 card-hover border border-border animate-float-up ${className}`;
  if (isExternalCard(card)) return <a href={homeCardLink(card)} target="_blank" rel="noreferrer noopener" data-testid={testid} className={base} style={style}>{inner}</a>;
  return <Link to={homeCardLink(card)} data-testid={testid} className={base} style={style}>{inner}</Link>;
};

export default EditorialCard;
